<template>
  <div class="logo">
    <router-link to="/">
      <img :src="desktopLogoUrl || voxyLogoPath" class="logo__img" />
    </router-link>
    <div v-if="!whitelabeled && !!desktopLogoUrl" class="powered-by-voxy-logo">
      <img :src="poweredByVoxyUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo',

  data() {
    return {
      voxyLogoPath: 'static/img/logo_voxy_header.png',
    };
  },

  computed: {
    userProfile() {
      return this.$store.getters.userProfile;
    },

    desktopLogoUrl() {
      if (this.userProfile.group && this.userProfile.group.image_url) {
        return this.userProfile.group.image_url;
      }

      if (this.userProfile.organization) {
        return this.userProfile.organization.image_url;
      }

      return null;
    },

    poweredByVoxyUrl() {
      return this.userProfile.organization ? this.userProfile.organization.powered_by_voxy_url : null;
    },

    whitelabeled() {
      return this.userProfile.organization ? this.userProfile.organization.is_whitelabeled : false;
    },
  },
};
</script>

<style lang="scss">
.logo {
  display: flex;
  align-items: center;
}

.logo__img {
  display: block;
  width: 100%;
  margin: auto;
}

.powered-by-voxy-logo {
  display: flex;
  padding: 10px;
  justify-content: center;
}
</style>
